import { useMutation, useQuery } from "@tanstack/react-query";

import api from "./apiClient";

import cookiesHelper from "../helpers/cookies";

import { HMICalculateAssessmentPrograms, IAssessmentProgramWithProgram } from "../interfaces/services";

import useToast from "./useToast";

export const useCalculateAssessmentPrograms = () => {
    const { addToast } = useToast();

    const mutationFn = async (data: HMICalculateAssessmentPrograms): Promise<void> => {
        const token = cookiesHelper.getCookie(`${process.env.REACT_APP_AUTH_TOKEN_NAME}`);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.post(`assessment-programs/calculate/${data.assessmentId}`);
        return response.data;
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (_, variables) => {
            if (variables.successCallback) {
                variables.successCallback();
            };
        },
        onError: (error: any) => {
            addToast({
                type: 'error',
                title: error.response.data.message,
            });
        },
        onSettled: (_, __, variables) => {
            variables.setIsProcessing(false);
        },
    });
};

export const useGetAssessmentPrograms = (assessmentId: string | undefined) => {
    const queryFn = async (): Promise<IAssessmentProgramWithProgram[]> => {
        const token = cookiesHelper.getCookie(`${process.env.REACT_APP_AUTH_TOKEN_NAME}`);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get(`assessment-programs/${assessmentId}`);
        return response.data;
    };

    return useQuery({
        queryKey: ['assessment-programs', assessmentId],
        queryFn,
        retry: 0,
        enabled: !!assessmentId,
    });
};
